export default "__VITE_ASSET__CVVbXLwv__"